import { RetracementIndicator } from "./RetracementIndicator";
import { DrawingService, SeriesTypes } from 'src/app/Services/DrawingService';
import { Time } from "./lcharts/src/api/data-consumer";
import { RetracementAccesabilityService } from "../Services/RetracementAccesability.service";
import { StoreRetracementReq } from "../Services/dg-hub-client.service";
import { RetracementMenu } from "./RetracementMenu";
import { ISeriesApi } from "./lcharts/src/api/iseries-api";

export class ActiveRetracements {

  public retracementsMenu:RetracementMenu;

  public activeRetracements: Map<string, activeRetracement> = new Map<string, activeRetracement>();


  constructor(public drawingService: DrawingService, public excludesService: RetracementAccesabilityService) {
    this.retracementsMenu = new RetracementMenu(this.drawingService)
  };

  public activeNewRetracementIndicator(serieId: number, time?: Time, auto?: boolean, isReload?:boolean, isExpanded?:boolean) {


    let index = String(serieId) + String(time);
    let clickedExist = this.activeRetracements.get(index);





    if (clickedExist) {
      jQuery('.rItem').remove();
      clickedExist.retracement.removeSeries();
      this.activeRetracements.delete(index);
      this.storeActiveRetracement()
      return;
    }


    let singleRetracements = new RetracementIndicator(this.drawingService);
    singleRetracements.updateSettings(this.drawingService.retracementSettings);
    singleRetracements.targetChart = this.drawingService.chart.chart;
    //singleRetracements.pregenerateFibonancciLevels();

    let rt = new activeRetracement();
    rt.serieID = serieId;
    rt.retracement = singleRetracements;

    if(isExpanded)
    rt.expanded = isExpanded;

    if (auto == true) {
      rt.auto = true;
    }

    this.activeRetracements.set(index, rt)
    // [rt.serieID] = rt;


    let serie = this.findSourceSerie(serieId);




    this.activeRetracements.get(index).retracement.addFibonacciSectionTimeRange(serie, time);

    if (!auto && !isReload) {
      this.storeActiveRetracement();
    }

  }


  public removeVisibleRetracement()
  {
    var activeRetracements = [...this.activeRetracements.values()];
    activeRetracements.forEach((mapActive)=>{
        mapActive.retracement.removeSeries();
    })
    this.activeRetracements.clear();

    jQuery('.rItem').remove();
    this.storeActiveRetracement();
    //this.drawingService.activeRetracements.removeRetracement(this.activeRetracement.retracement)
  }

  public removeRetracement(selected: RetracementIndicator)
  {

    let mapRActive = [...this.activeRetracements.values()];
    let mapActive = [...this.activeRetracements.values()].find(v=>{
      return v.retracement.lastTimeStart == selected.lastTimeStart &&
      v.retracement.lastTimeEnd == selected.lastTimeEnd &&
      v.retracement.waveType == selected.waveType;
    });

    let index = String(mapActive.serieID) + String(mapActive.retracement.lastTimeStart);

    jQuery('.rItem').remove();

      mapActive.retracement.removeSeries();
     this.activeRetracements.delete(index);
     this.storeActiveRetracement()
  }

  public findSourceSerie(serieId) {
    let model = this.drawingService.chart.chart.getChartModel();
    let activeSeries = model.getSeries();

    let selectedSerie = activeSeries.find(v => {
      return v.serieIndex == serieId && v._seriesType == 'Line'
    })

    return selectedSerie;
  }

  public async removeAllSeries() {

    Array.from(this.activeRetracements.keys()).forEach(
      key => {
        let item = this.activeRetracements.get(key);
        item.retracement.removeSeries();
        item.retracement.redraw();
      }
    );

  }

  public redraw() {
    this.removeAllSeries();
  }

  public lastTimes: Time[] = [];
  public lastAutoRetracementTimes: lastRetracement;
  public sliceRetracement(serieId: number, time?: Time) {

    let index = String(serieId) + String(time);
    let clickedExist = this.activeRetracements.get(index);


    if (clickedExist) {
      clickedExist.retracement.removeSeries();
      this.activeRetracements.delete(index);
      this.lastTimes.push(time);
    }

  }


  public pushAutoRetracement(serieId: number, time?: Time) {
    //  return;

    let index = String(serieId) + String(time);

    if (this.lastAutoRetracementTimes) {

      let index = String(this.lastAutoRetracementTimes.serieID) + String(this.lastAutoRetracementTimes.time);
      let last = this.activeRetracements.get(index);
      if (last) {
        last.retracement.removeSeries();
        this.activeRetracements.delete(index);
      }

    }
    this.lastAutoRetracementTimes = { serieID: serieId, time: time };
    this.activeNewRetracementIndicator(serieId, time, true);
//////////////////////////////////

    let lastWaves = this.drawingService.waveComputer.getLastWaves(3);

    let times = lastWaves.map(v=>{
      return v.data[0].time
    })


    let ac = Array.from(this.activeRetracements);

    let acFilter = ac.filter(v=>{
      return times.indexOf(v[1].retracement.lastTimeStart)>-1
    })

    let p:storedRetracements[]=[];
  //  //console.log(acFilter);
  this.lastTimes.forEach(v=>{

    if(time!= v)
    {
       p.push({
        time: v,
        type: SeriesTypes.PERNAMENT
      })
    }

  })


      this.restorSavedRetracement(JSON.stringify(p));

  }

  public storedRetracement: storedRetracements[] = [];

  public storeActiveRetracement() {
    //console.log("storeLastRetracements");
    this.storedRetracement = [];
    Array.from(this.activeRetracements.keys()).forEach(key => {
      // each key of foo
      let item = this.activeRetracements.get(key);
      let serieParams = this.drawingService.mapSeriesMap.get(item.serieID);
      let serie = this.findSourceSerie(item.serieID);

      if (serie!=undefined && serie._data._bars._items[0].time.timestamp == item.retracement.lastTimeStart) {

        if (!item.auto) {
          this.storedRetracement.push(
            {
              time: item.retracement.lastTimeStart,
              type: serieParams.type,
              expanded: item.expanded
            }
          )
        }

      }


    })

    let strKey = `${this.drawingService.mainConfig.pernamentLineHeight}_${this.drawingService.mainConfig.intermediateLineHeight}`;
    let data = JSON.stringify(this.storedRetracement);

    let req: StoreRetracementReq = {
      key: strKey,
      data: data,
      viewName: this.drawingService.selectedViewName
    }
    this.lastSelectedStr = data;
    this.drawingService.dataService.getHubCLientService().StoreActiveRetracement(req);

  }

  public getActiveRetracements()
  {
    Array.from(this.activeRetracements.keys()).forEach(key => {
      // each key of foo
      let item = this.activeRetracements.get(key);
      let serieParams = this.drawingService.mapSeriesMap.get(item.serieID);
      let serie = this.findSourceSerie(item.serieID);

      if (serie!=undefined && serie._data._bars._items[0].time.timestamp == item.retracement.lastTimeStart) {

        if (!item.auto) {
          this.storedRetracement.push(
            {
              time: item.retracement.lastTimeStart,
              type: serieParams.type,
              expanded: item.expanded
            }
          )
        }

      }


    })

    let strKey = `${this.drawingService.mainConfig.pernamentLineHeight}_${this.drawingService.mainConfig.intermediateLineHeight}`;
    let data = JSON.stringify(this.storedRetracement);

    let req: StoreRetracementReq = {
      key: strKey,
      data: data,
      viewName: this.drawingService.selectedViewName
    }
    return req;
  }










  public lastSelected: storedRetracements[]
  public lastSelectedStr: string;
  public async restorSavedRetracement(lsatSelected: string) {
    return new Promise<boolean>((resolve, reject) => {
    let model = this.drawingService.chart.chart.getChartModel();
    this.lastSelected = JSON.parse(lsatSelected);
    this.lastSelectedStr = lsatSelected;
    if(this.lastSelected==null)
    {
      resolve(true);
      return;
    }

    let activeSeries = model.getSeries();
    let toRestore: lastRetracementRestore[] = [];
    this.lastSelected =  this.lastSelected.filter((v,i,a)=>a.findIndex(t=>(t.time === v.time && t.type===v.type))===i)
    this.lastSelected.forEach(v => {

      let correct = activeSeries.filter(serie => {

        try {
          if(serie._data._bars._items[0])
          {
             return serie._data._bars._items[0].time.timestamp == v.time
          }
          else
          {
            return false;
          }
        }
        catch (e) {
          //console.log(e);
        }

      })

      correct.forEach(k => {

        let serieParams = this.drawingService.mapSeriesMap.get(k.serieIndex);


        if (serieParams && serieParams.type == v.type) {
          toRestore.push({
            serieID: k.serieIndex,
            time: v.time,
            type: v.type,
            expanded: v.expanded
          })
        }
      })



    })

    //console.log(toRestore);


    toRestore.forEach(l=>{

       this.activeNewRetracementIndicator(l.serieID, l.time, false, true, l.expanded);

    })

    resolve(true);
  })
  }



}

export class activeRetracement {
  serieID: number = -1;
  retracement: RetracementIndicator;
  auto: boolean = false;
  expanded:boolean = false
}

export class lastRetracement {
  serieID: number;
  time: Time
}

export class lastRetracementRestore {
  serieID: number;
  time: Time;
  type: SeriesTypes;
  expanded?:boolean
}

export class storedRetracements {
  time: Time;
  type: SeriesTypes;
  expanded?:boolean
}
